import { useMemo, useState } from 'react'
import type { CatalogFilters, CatalogRow } from './CatalogList.types'

export function useCatalogFilters(rows: CatalogRow[]) {
  const [filters, setFilters] = useState<CatalogFilters>({
    contractVehicle: '',
    contractNumber: '',
    status: '',
    contractType: '',
    setAside: '',
  })

  const filteredRows = useMemo(() => {
    const contractNumber = filters.contractNumber.trim().toLowerCase()

    return rows.filter(r => {
      const matchesVehicle = !filters.contractVehicle || r.contractVehicle === filters.contractVehicle
      const matchesNumber = !contractNumber || r.contractNumber.toLowerCase().includes(contractNumber)
      const matchesStatus = !filters.status || r.status === filters.status
      const matchesType = !filters.contractType || r.contractType === filters.contractType
      const matchesSetAside = !filters.setAside || r.setAside === filters.setAside

      return matchesVehicle && matchesNumber && matchesStatus && matchesType && matchesSetAside
    })
  }, [rows, filters])

  const vehicleOptions = useMemo(() => {
    return Array.from(new Set(rows.map(r => r.contractVehicle))).sort()
  }, [rows])

  const contractTypeOptions = useMemo(() => {
    return Array.from(new Set(rows.map(r => r.contractType).filter(Boolean))).sort()
  }, [rows])

  const setAsideOptions = useMemo(() => {
    return Array.from(new Set(rows.map(r => r.setAside).filter(Boolean))).sort()
  }, [rows])

  return {
    filters,
    setFilters,
    filteredRows,
    vehicleOptions,
    contractTypeOptions,
    setAsideOptions,
  }
}
